import classnames from 'classnames';
import React from 'react';

// eslint-disable-next-line
// @ts-ignore
import styles from '../../styles/index.scss';
import { DocLink } from '../DocLink';
import { DrawerSideBox } from '../Drawer/DrawerSideBox';
import { useLayout } from '../LayoutNext/LayoutProvider';
import { Navigation } from './Navigation/Navigation';

export const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  React.useEffect(() => {
    styles?.use?.(); // Keep this as optional to unblock test runner

    return () => {
      styles?.unuse?.(); // Keep this as optional to unblock test runner
    };
  }, []);

  const { nav } = useLayout();

  return (
    <div className={classnames('layout', { 'layout--nav-collapsed': !nav.isOpen })}>
      <DocLink />
      <nav
        className={classnames('layout__navigation', { collapsed: !nav.isOpen, collapsing: nav.isAnimating })}
        role="navigation"
      >
        <DrawerSideBox toggleDrawer={nav.toggle}>
          <Navigation isDrawerOpen={nav.isOpen} />
        </DrawerSideBox>
      </nav>
      <div className="layout__content">{children}</div>
    </div>
  );
};
